import { FilterPopover, type Align, type SortProps } from './FilterPopover';
import { OptionChecklist } from './OptionChecklist';

export interface MultiSelectOption {
  value: string;
  label: string;
}

interface Props extends SortProps {
  label: string;
  align?: Align;
  value: string[];
  options: MultiSelectOption[];
  onChange: (next: string[]) => void;
  searchable?: boolean;
  searchPlaceholder?: string;
}

/** Categorical column: tick any number of known values. */
export function MultiSelectFilterPopover({
  label,
  align,
  value,
  options,
  onChange,
  searchable = false,
  searchPlaceholder = 'Search…',
  ...sortProps
}: Props) {
  return (
    <FilterPopover<string[]>
      label={label}
      align={align}
      {...sortProps}
      filterActive={value.length > 0}
      value={value}
      emptyValue={[]}
      onChange={onChange}
      isEmpty={(d) => d.length === 0}
      width="17rem"
      render={({ draft, setDraft }) => (
        <OptionChecklist
          options={options}
          selected={draft}
          onChange={setDraft}
          searchable={searchable}
          searchPlaceholder={searchPlaceholder}
          autoFocusSearch
        />
      )}
    />
  );
}
